import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

export const getAllEmployers = async ({
  page,
  size,
  search,
  location,
  category,
}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (!API_ENDPOINTS?.EMPLOYERS) {
    throw new Error("Endpoint de employers não configurado");
  }

  return apiRequest(
    `${API_ENDPOINTS.EMPLOYERS}?${params.toString()}&sort=createdAt,desc`,
    {
      fallbackMessage: "Erro ao buscar employers",
      errorCode: "EMPLOYER_LIST_FAILED",
    }
  );
};

export const getCompanyVacancies = async ({ id, page, size }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (!API_ENDPOINTS?.EMPLOYERS) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.EMPLOYERS}/${id}/vacancies?sort=createdAt,desc`, {
    fallbackMessage: "Erro ao buscar vagas",
    errorCode: "EMPLOYER_VACANCIES_FAILED",
  });
};

export const getEmployerById = async (employerId) => {
  return apiRequest(`${API_ENDPOINTS.EMPLOYERS}/${employerId}`, {
    fallbackMessage: `Failed to fetch employer with ID: ${employerId}`,
    errorCode: "EMPLOYER_FETCH_FAILED",
  });
};
